import paths from 'router/paths';

export const announcementAllUrl = `${encodeURI(paths.ANNOUNCEMENT_PATH)}/all`;

export const announcementDetailUrl = (
    seq: number | undefined,
    title: string | undefined
) => {
    return `${encodeURI(paths.ANNOUNCEMENT_DETAIL_PATH)}/${seq}/${title}`;
};

export const announcementType = (type: string) =>
    ({ U: 'update', E: 'event', N: 'notice' }[type] || 'unknown');

export const announcementTypeUrl = (type: string) => {
    const announceType = announcementType(type);

    return `${encodeURI(paths.ANNOUNCEMENT_PATH)}/${announceType}`;
};

export const registerUrl = `${paths.REGISTER_PATH}`;
